/**
 * GENERATED by scripts/generate-board-steps.ts from the committed docs/living/planner-magic-canvas/Chapter2.dc.html — DO NOT EDIT.
 * Regenerate with `npm run board:generate`; `npm run check:board-parity` fails when this file and the board disagree.
 */

import { SAGE } from "../brand";

export const BOARD_STEPS_CH2 = [
  {
    "kind": "choice",
    "key": "prop",
    "multi": true,
    "compact": true,
    "crumb": "Home and property",
    "title": "Your home and other places",
    "why": "Where you live, and anything else you own or rent. Say who the lender and the insurer are — those are the first two calls.",
    "options": [
      {
        "id": "lown",
        "grp": "live",
        "one": true,
        "pinTo": "own",
        "head": "Where you live",
        "label": "I own it",
        "mark": "OWN",
        "color": SAGE[600],
        "cover": 4
      },
      {
        "id": "lrent",
        "grp": "live",
        "one": true,
        "pinTo": "rent",
        "label": "I rent it",
        "mark": "RENT",
        "color": "#2F7FB8",
        "cover": 3
      },
      {
        "id": "fam",
        "grp": "live",
        "one": true,
        "oneLine": true,
        "lead": "Family or care home",
        "label": "With family, or in a care home",
        "mark": "FAM",
        "color": "#7A6BA8",
        "prune": 4,
        "cover": 3,
        "lines": [
          {
            "kind": "person",
            "k": "whose",
            "word": "Name someone",
            "label": "Whose home is it?",
            "title": "Whose home is it?",
            "org": true,
            "w": "300px"
          },
          {
            "kind": "seg",
            "k": "care",
            "label": "Is it a retirement residence or a care home?",
            "opts": [
              "Yes",
              "No"
            ],
            "then": {
              "Yes": [
                {
                  "kind": "person",
                  "k": "residence",
                  "word": "Name it",
                  "label": "Name of the residence",
                  "title": "Name of the residence",
                  "org": true,
                  "w": "300px"
                },
                {
                  "kind": "seg",
                  "k": "deposit",
                  "label": "A deposit or prepaid fees?",
                  "opts": [
                    "Yes",
                    "No",
                    "Not sure"
                  ]
                }
              ]
            }
          }
        ],
        "noteFor": {
          "care": "There is notice to give and often a deposit or prepaid fees to be refunded — money that goes back to the estate and is regularly left behind. Both are on your executor’s list either way."
        }
      },
      {
        "id": "own",
        "head": "Other places",
        "label": "I own other places",
        "mark": "OWN",
        "color": "#7A6BA8",
        "cover": 3,
        "lead": "Places you own",
        "addLabel": "Add another place you own",
        "rows": {
          "cols": "190px minmax(250px, 1fr) 150px 133px 262px",
          "start": 1,
          "headers": [
            {
              "label": "What is it?"
            },
            {
              "label": "Address"
            },
            {
              "label": "Estimated value"
            },
            {
              "label": "Person named in will"
            }
          ],
          "cells": [
            {
              "kind": "picker",
              "k": "kind",
              "ph": "Choose…",
              "opts": [
                "A second home",
                "A cottage or cabin",
                "Land",
                "A timeshare",
                "A parking space",
                "Other — type it"
              ],
              "otherLabel": "Type what it is",
              "otherPh": "e.g. a hunting camp"
            },
            {
              "kind": "address",
              "k": "addr",
              "ph": "Type the address…"
            },
            {
              "kind": "text",
              "k": "worth",
              "ph": "$850,000"
            },
            {
              "kind": "picker",
              "k": "will",
              "cardTitles": [
                "Who does your will leave it to?",
                "Who should have it?"
              ],
              "ph": "Choose…",
              "opts": [
                "Yes",
                "No",
                "Not sure"
              ],
              "offWhen": {
                "k": "tenure",
                "v": "Jointly — it goes to them",
                "unless": {
                  "k": "gift",
                  "v": [
                    "No — I added them to help",
                    "Not sure"
                  ]
                }
              }
            },
            {
              "kind": "lines",
              "lines": [
                {
                  "kind": "person",
                  "k": "coowner",
                  "word": "Name someone",
                  "label": "Is anyone else on the title?",
                  "title": "Who else is on the title?",
                  "w": "260px",
                  "then": [
                    {
                      "kind": "seg",
                      "k": "tenure",
                      "label": "How do you own it together?",
                      "hint": "it decides whether your will covers this place at all",
                      "opts": [
                        "Jointly — it goes to them",
                        "In shares — mine follows my will",
                        "Not sure"
                      ],
                      "then": {
                        "Jointly — it goes to them": [
                          {
                            "kind": "seg",
                            "k": "gift",
                            "label": "Was it meant as a gift to them?",
                            "hint": "if it was not a gift, the law treats it as still yours",
                            "opts": [
                              "Yes",
                              "No — I added them to help",
                              "Not sure"
                            ]
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  "kind": "seg",
                  "k": "mortgage",
                  "label": "Mortgage or loan?",
                  "opts": [
                    "Yes",
                    "No"
                  ],
                  "then": {
                    "Yes": [
                      {
                        "kind": "person",
                        "k": "lender",
                        "word": "Name the lender",
                        "label": "Who is it with?",
                        "title": "Who is the lender?",
                        "org": true,
                        "w": "260px"
                      },
                      {
                        "kind": "text",
                        "k": "owing",
                        "label": "Amount owing",
                        "text": "$240,000",
                        "w": "200px"
                      },
                      {
                        "kind": "text",
                        "k": "monthly",
                        "label": "Monthly payment",
                        "text": "$1,900",
                        "w": "160px"
                      },
                      {
                        "kind": "break"
                      },
                      {
                        "kind": "person",
                        "k": "cosign",
                        "word": "Name someone",
                        "label": "Is anyone else on this loan?",
                        "title": "Who else is on this loan?",
                        "w": "260px"
                      },
                      {
                        "kind": "seg",
                        "k": "protect",
                        "label": "Is there mortgage insurance on it?",
                        "opts": [
                          "Yes",
                          "No"
                        ]
                      }
                    ]
                  }
                },
                {
                  "kind": "seg",
                  "k": "rentout",
                  "label": "Rented out?",
                  "opts": [
                    "Yes",
                    "No"
                  ],
                  "then": {
                    "Yes": [
                      {
                        "kind": "person",
                        "k": "tenant",
                        "word": "Name someone",
                        "label": "Who is the tenant?",
                        "title": "Who is the tenant?",
                        "w": "300px"
                      },
                      {
                        "kind": "seg",
                        "k": "lmrtaken",
                        "label": "Did you take a rent deposit?",
                        "opts": [
                          "Yes",
                          "No"
                        ],
                        "then": {
                          "Yes": [
                            {
                              "kind": "text",
                              "k": "depamt",
                              "label": "How much",
                              "text": "$2,400",
                              "w": "200px"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  "kind": "seg",
                  "k": "ins",
                  "inline": true,
                  "label": "Is there house insurance?",
                  "opts": [
                    "Yes",
                    "No"
                  ],
                  "then": {
                    "Yes": [
                      {
                        "kind": "person",
                        "k": "insurer",
                        "word": "Name the insurer",
                        "label": "Who is the property insurer?",
                        "title": "Who is the property insurer?",
                        "org": true,
                        "w": "280px"
                      },
                      {
                        "kind": "seg",
                        "k": "brk",
                        "label": "Who do you deal with?",
                        "opts": [
                          "A broker or agent",
                          "Direct with the insurer",
                          "Not sure"
                        ],
                        "then": {
                          "A broker or agent": [
                            {
                              "kind": "person",
                              "k": "broker",
                              "word": "Name someone",
                              "label": "Which broker or brokerage?",
                              "hint": "a name gets your executor to the policy in one call",
                              "title": "Which broker or agent?",
                              "org": true,
                              "w": "320px"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  "kind": "text",
                  "k": "keys",
                  "big": true,
                  "label": "Where are the keys kept?",
                  "text": "e.g. On the hook by the side door",
                  "w": "300px"
                }
              ]
            }
          ]
        },
        "noteFor": {
          "tenure": {
            "In shares — mine follows my will": "Your share is written on the transfer from when you bought — chapter five asks where that paper is.",
            "Not sure": "It is written on the transfer from when you bought — chapter five asks where that paper is."
          },
          "gift": {
            "No — I added them to help": "Then the law treats the place as still yours to leave, even though you hold it jointly — so your will decides it after all.",
            "Not sure": "Then your executor may have to show what you meant. Without a gift, the law treats the place as still yours, and your will decides it."
          },
          "mortgage": "The loan stays attached to this property, not to your other debts. Someone has to keep the payments going until it is sold or transferred — which is why the monthly amount matters.",
          "protect": "If the mortgage is insured, the insurer pays off what is left. Your executor files that claim before anything is sold."
        }
      },
      {
        "id": "rent",
        "label": "I rent other places",
        "mark": "RENT",
        "color": "#2F7FB8",
        "cover": 1,
        "lead": "Places you rent",
        "addLabel": "Add another place you rent",
        "rows": {
          "cols": "214px minmax(142px, 1fr) 170px 120px 262px",
          "start": 1,
          "headers": [
            {
              "label": "What is it?"
            },
            {
              "label": "Address"
            },
            {
              "label": "Rented from"
            },
            {
              "label": "Monthly rent"
            }
          ],
          "cells": [
            {
              "kind": "picker",
              "k": "kind",
              "ph": "Choose…",
              "opts": [
                "A storage unit",
                "A parking space",
                "A flat or house",
                "A garage or workshop",
                "A locker",
                "Other — type it"
              ],
              "otherLabel": "What is it?",
              "otherPh": "e.g. a boat slip"
            },
            {
              "kind": "address",
              "k": "addr",
              "ph": "Type the address…"
            },
            {
              "kind": "person",
              "k": "landlord",
              "word": "Name someone",
              "title": "Who is it rented from?",
              "org": true
            },
            {
              "kind": "text",
              "k": "monthly",
              "ph": "$190"
            },
            {
              "kind": "lines",
              "lines": [
                {
                  "kind": "seg",
                  "k": "lease",
                  "label": "Lease",
                  "opts": [
                    "A fixed term",
                    "Month to month"
                  ],
                  "then": {
                    "A fixed term": [
                      {
                        "kind": "date",
                        "k": "leaseend",
                        "label": "End date",
                        "w": "200px"
                      }
                    ]
                  }
                },
                {
                  "kind": "seg",
                  "k": "lmrpaid",
                  "label": "Did you pay a rent deposit?",
                  "opts": [
                    "Yes",
                    "No"
                  ],
                  "then": {
                    "Yes": [
                      {
                        "kind": "text",
                        "k": "depamt",
                        "label": "How much",
                        "text": "$2,400",
                        "w": "200px"
                      }
                    ]
                  }
                },
                {
                  "kind": "text",
                  "k": "keys",
                  "big": true,
                  "label": "Where are the keys kept?",
                  "text": "e.g. On the hook by the side door",
                  "w": "300px"
                }
              ]
            }
          ],
          "pinLines": [
            {
              "kind": "seg",
              "k": "lease",
              "label": "Lease",
              "opts": [
                "A fixed term",
                "Month to month"
              ],
              "then": {
                "A fixed term": [
                  {
                    "kind": "date",
                    "k": "leaseend",
                    "label": "End date",
                    "w": "200px"
                  }
                ]
              }
            },
            {
              "kind": "person",
              "k": "cotenant",
              "word": "Name someone",
              "label": "Is anyone else on the lease?",
              "title": "Who else is on the lease?",
              "w": "260px"
            },
            {
              "kind": "seg",
              "k": "lmrpaid",
              "label": "Did you pay a rent deposit?",
              "opts": [
                "Yes",
                "No"
              ],
              "then": {
                "Yes": [
                  {
                    "kind": "text",
                    "k": "depamt",
                    "label": "How much",
                    "text": "$2,400",
                    "w": "200px"
                  }
                ]
              }
            },
            {
              "kind": "text",
              "k": "keys",
              "big": true,
              "label": "Where are the keys kept?",
              "text": "e.g. On the hook by the side door",
              "w": "300px"
            }
          ],
          "pinNote": "In Ontario, if you are the only tenant, the tenancy ends by itself 30 days afterwards — your executor has that month to clear the place. If someone else is on the lease, it carries on for them."
        }
      },
      {
        "id": "no",
        "label": "No other places",
        "none": true,
        "prune": 4
      }
    ]
  },
  {
    "kind": "choice",
    "key": "veh",
    "crumb": "Vehicles",
    "title": "Vehicles",
    "why": "Anything with a registration. Nobody can insure, move or sell one until they know it exists and who it belongs to.",
    "options": [
      {
        "id": "yes",
        "addLabel": "Add another vehicle",
        "label": "Yes, I have vehicles",
        "mark": "VEH",
        "color": "#003DA5",
        "cover": 2,
        "rows": {
          "cols": "196px 65px 158px minmax(97px, 1fr) 120px 94px 104px 133px 262px",
          "start": 1,
          "headers": [
            {
              "label": "Vehicle"
            },
            {
              "label": "Year"
            },
            {
              "label": "Make and model"
            },
            {
              "label": "Where is it?"
            },
            {
              "label": "Estimated value"
            },
            {
              "label": "Loan or lease?"
            },
            {
              "label": "Insurance on it?"
            },
            {
              "label": "Person named in will"
            }
          ],
          "cells": [
            {
              "kind": "picker",
              "k": "kind",
              "ph": "Choose…",
              "opts": [
                "Car",
                "Motorcycle",
                "Boat",
                "Trailer",
                "RV or camper",
                "Snowmobile or ATV",
                "Aircraft",
                "Other — type it"
              ]
            },
            {
              "kind": "text",
              "k": "year",
              "ph": "Year"
            },
            {
              "kind": "text",
              "k": "make",
              "ph": "e.g. Honda CR-V"
            },
            {
              "kind": "text",
              "k": "where",
              "long": true,
              "ph": "e.g. Bala marina",
              "bigTitle": "Where is it, and where are the keys?",
              "bigHint": "A marina or a storage lot needs directions; a driveway does not. Say where the keys and any spare are kept.",
              "bigPh": "e.g. Bala marina, slip 14. The office is the green building at the top of the ramp, and they hold a spare key. My keys are on the hook by the side door.",
              "sample": "Bala marina, slip 14. The office is the green…"
            },
            {
              "kind": "text",
              "k": "worth",
              "ph": "$18,000"
            },
            {
              "kind": "seg",
              "k": "loan",
              "opts": [
                "Yes",
                "No"
              ],
              "then": {
                "Yes": [
                  {
                    "kind": "person",
                    "k": "lender",
                    "word": "Name the lender",
                    "label": "Who is it with?",
                    "title": "Who is the lender?",
                    "org": true,
                    "w": "260px"
                  },
                  {
                    "kind": "text",
                    "k": "owing",
                    "label": "Amount owing",
                    "text": "$14,000",
                    "w": "200px"
                  },
                  {
                    "kind": "text",
                    "k": "monthly",
                    "label": "Monthly payment",
                    "text": "$450",
                    "w": "160px"
                  },
                  {
                    "kind": "break"
                  },
                  {
                    "kind": "person",
                    "k": "cosign",
                    "word": "Name someone",
                    "label": "Is anyone else on this loan?",
                    "title": "Who else is on this loan?",
                    "w": "260px"
                  }
                ]
              }
            },
            {
              "kind": "seg",
              "k": "ins",
              "opts": [
                "Yes",
                "No"
              ],
              "then": {
                "Yes": [
                  {
                    "kind": "person",
                    "k": "insurer",
                    "word": "Name the insurer",
                    "label": "Who is the insurer?",
                    "title": "Who is the insurer?",
                    "org": true,
                    "w": "280px"
                  },
                  {
                    "kind": "seg",
                    "k": "brk",
                    "label": "Who do you deal with?",
                    "opts": [
                      "A broker or agent",
                      "Direct with the insurer",
                      "Not sure"
                    ],
                    "then": {
                      "A broker or agent": [
                        {
                          "kind": "person",
                          "k": "broker",
                          "word": "Name someone",
                          "label": "Which broker or brokerage?",
                          "hint": "a name gets your executor to the policy in one call",
                          "title": "Which broker or agent?",
                          "org": true,
                          "w": "320px"
                        }
                      ]
                    }
                  }
                ]
              }
            },
            {
              "kind": "picker",
              "k": "will",
              "cardTitles": [
                "Who does your will leave it to?",
                "Who should have it?"
              ],
              "ph": "Choose…",
              "opts": [
                "Yes",
                "No",
                "Not sure"
              ]
            }
          ]
        }
      },
      {
        "id": "no",
        "label": "No",
        "none": true,
        "prune": 3
      }
    ]
  },
  {
    "kind": "choice",
    "key": "val",
    "crumb": "Valuables",
    "title": "Valuables and Heirlooms",
    "why": "Select anything worth money, or that someone might argue over, wherever it is kept — jewellery, art, a collection, a watch, an instrument, tools.",
    "options": [
      {
        "id": "yes",
        "addLabel": "Add another valuable",
        "label": "Yes, there are valuables",
        "mark": "VAL",
        "color": "#B8860B",
        "cover": 3,
        "rows": {
          "cols": "minmax(165px, 1fr) 269px 150px 133px 262px",
          "start": 1,
          "headers": [
            {
              "label": "Item"
            },
            {
              "label": "Where is it kept?"
            },
            {
              "label": "Estimated value"
            },
            {
              "label": "Person named in will"
            }
          ],
          "cells": [
            {
              "kind": "text",
              "k": "item",
              "ph": "e.g. My mother’s ring"
            },
            {
              "kind": "text",
              "k": "where",
              "long": true,
              "ph": "e.g. In the house",
              "bigTitle": "Where is it kept?",
              "bigHint": "Say it the way you would tell a friend on the phone.",
              "bigPh": "e.g. In the small jewellery box on the dressing table, in the top drawer on the left.",
              "sample": "In the small jewellery box on the dressing table…"
            },
            {
              "kind": "text",
              "k": "worth",
              "ph": "$4,000"
            },
            {
              "kind": "picker",
              "k": "will",
              "cardTitles": [
                "Who does your will leave it to?",
                "Who should have it?"
              ],
              "ph": "Choose…",
              "opts": [
                "Yes",
                "No",
                "Not sure"
              ]
            }
          ]
        }
      },
      {
        "id": "no",
        "label": "No",
        "none": true,
        "prune": 3
      }
    ]
  },
  {
    "kind": "choice",
    "key": "fa",
    "crumb": "Firearms",
    "title": "Firearms",
    "why": "Firearms have their own rules and their own deadlines. Getting it wrong is a criminal matter, not a delay.",
    "options": [
      {
        "id": "yes",
        "addLabel": "Add another firearm",
        "label": "Yes, there are firearms in the home",
        "mark": "FA",
        "color": "#8B1E3F",
        "cover": 3,
        "rows": {
          "cols": "168px 240px minmax(180px, 1fr) 89px 133px 262px",
          "start": 1,
          "headers": [
            {
              "label": "Firearm"
            },
            {
              "label": "Where is it kept?"
            },
            {
              "label": "Who could legally take it?"
            },
            {
              "label": "In a gun safe?"
            },
            {
              "label": "Person named in will"
            }
          ],
          "cells": [
            {
              "kind": "picker",
              "k": "kind",
              "ph": "Choose…",
              "opts": [
                "Rifle",
                "Shotgun",
                "Handgun",
                "Restricted",
                "Prohibited",
                "Other — type it"
              ],
              "otherLabel": "What kind"
            },
            {
              "kind": "text",
              "k": "where",
              "long": true,
              "ph": "e.g. a gun cabinet",
              "bigTitle": "Where is it kept?",
              "bigHint": "Your executor has to secure these before anyone else is in the house.",
              "bigPh": "e.g. In the locked cabinet in the basement, behind the furnace room door. Unloaded.",
              "sample": "In the locked cabinet in the basement…"
            },
            {
              "kind": "person",
              "k": "taker",
              "word": "Name someone",
              "title": "Who could legally take it?"
            },
            {
              "kind": "seg",
              "k": "safe",
              "opts": [
                "Yes",
                "No"
              ]
            },
            {
              "kind": "picker",
              "k": "will",
              "cardTitles": [
                "Who does your will leave it to?",
                "Who should have it?"
              ],
              "ph": "Choose…",
              "opts": [
                "Yes",
                "No",
                "Not sure"
              ]
            }
          ]
        },
        "noteFor": {
          "safe": "The gun safe is added to Safes on the next screen."
        }
      },
      {
        "id": "no",
        "label": "No",
        "none": true,
        "prune": 4
      }
    ]
  },
  {
    "kind": "choice",
    "key": "safes",
    "crumb": "Safes",
    "title": "Safes and Locked Places",
    "why": "Anywhere that needs opening. A safe, a deposit box and a hiding place are three different problems.",
    "options": [
      {
        "id": "yes",
        "addLabel": "Add another safe or locked place",
        "label": "Yes, there is a safe or locked place",
        "mark": "KEY",
        "color": "#E08A2E",
        "cover": 3,
        "rows": {
          "cols": "206px minmax(130px, 1fr) 156px 168px 150px 160px 262px",
          "start": 1,
          "headers": [
            {
              "label": "Place"
            },
            {
              "label": "Where is it kept?"
            },
            {
              "label": "What is in it?"
            },
            {
              "label": "How does it open?"
            },
            {
              "label": "Where is the key?"
            },
            {
              "label": "Who else can open it?"
            }
          ],
          "cells": [
            {
              "kind": "picker",
              "k": "kind",
              "ph": "Choose…",
              "opts": [
                "A safe",
                "A safety deposit box",
                "A locked cabinet",
                "A hiding place",
                "Other — type it"
              ]
            },
            {
              "kind": "text",
              "k": "where",
              "long": true,
              "ph": "e.g. basement",
              "bigTitle": "Where is it kept?",
              "bigHint": "Your executor may never have been inside your home.",
              "bigPh": "e.g. In the basement, through the door under the stairs. It is behind the shelf of paint tins, on the floor, covered with an old blue blanket.",
              "sample": "In the basement, through the door under the stairs…"
            },
            {
              "kind": "text",
              "k": "contents",
              "long": true,
              "ph": "e.g. passports",
              "bigTitle": "What is in it?",
              "bigHint": "A list is fine.",
              "bigPh": "e.g. Both passports, the original will, the deed to the cottage, my mother’s rings.",
              "sample": "Both passports, the original will, the deed…"
            },
            {
              "kind": "picker",
              "k": "lock",
              "ph": "Choose…",
              "opts": [
                "A key",
                "A dial",
                "A keypad",
                "Other — type it"
              ],
              "otherLabel": "What kind of lock",
              "otherPh": "e.g. a fingerprint reader"
            },
            {
              "kind": "text",
              "k": "keyat",
              "long": true,
              "ph": "e.g. a drawer",
              "bigTitle": "Where is the key kept?",
              "bigHint": "The place, never the code. A safe nobody can open is the same as a safe nobody can find.",
              "bigPh": "e.g. Taped to the underside of the top drawer of the desk in the study. There is a spare with my sister.",
              "sample": "Taped under the top drawer of the desk…"
            },
            {
              "kind": "person",
              "k": "opener",
              "word": "Name someone",
              "title": "Who else can open it?"
            }
          ]
        }
      },
      {
        "id": "no",
        "label": "No",
        "none": true,
        "prune": 2
      }
    ],
    "foot": ""
  },
  {
    "kind": "end",
    "key": "end",
    "title": "That is chapter two.",
    "why": "Everything you can put a hand on is now written down."
  }
];
